const actionTypeIdentifier = 'E037CE2F-91FE-4FF4-9D09-33C092275694'; //action identifier should be unique in every model settings

export const setRequestTypes = `SET-ORDER-REQUEST-TYPES-${actionTypeIdentifier}`;
export const setDisplaySearch = `SET-DISPLAY-SEARCH-${actionTypeIdentifier}`;
export const setRequestLoading = `SET-REQUEST-LOADING-${actionTypeIdentifier}`;
//Table Search by Column Data
export const setRequestSearch = `SET-ORDER-SEARCH-${actionTypeIdentifier}`;
export const setAllRequestSearch = `SET-ALL-REQUEST-SEARCH-${actionTypeIdentifier}`;
export const setApprovalSearch = `SET-APPROVAL-SEARCH-${actionTypeIdentifier}`;
export const setQuotationSearch = `SET-QUOTATION-SEARCH-${actionTypeIdentifier}`;
//Table Page Size
export const setMyRequestPageSize = `SET-MY-REQUEST-PAGE-SIZE-${actionTypeIdentifier}`;
export const setAllRequestPageSize = `SET-ALL-REQUEST-PAGE-SIZE-${actionTypeIdentifier}`;
export const setApprovalRequestPageSize = `SET-APPROVAL-REQUEST-PAGE-SIZE-${actionTypeIdentifier}`;
export const setQuotationRequestPageSize = `SET-QUOTATION-REQUEST-PAGE-SIZE-${actionTypeIdentifier}`;
//Table Result Data
export const setOrderAllRequestData = `SET-ORDER-ALL-REQUEST-DATA-${actionTypeIdentifier}`;
export const setOrderRequestData = `SET-ORDER-REQUEST-DATA-${actionTypeIdentifier}`;
export const setOrderApprovalData = `SET-ORDER-APPROVAL-DATA-${actionTypeIdentifier}`;
export const setOrderCoverageData = `SET-ORDER-COVERAGE-DATA-${actionTypeIdentifier}`;
export const setOrderQuotationData = `SET-ORDER-QUOTATION-DATA-${actionTypeIdentifier}`;
//Table Manipulation Data            
export const setActiveRequestTable = `SET-ACTIVE-REQUEST-TABLE-${actionTypeIdentifier}`;
export const setOrderSearchValue = `SET-ORDER-SEARCH-DATA-${actionTypeIdentifier}`;
export const setOrderFilterData = `SET-ORDER-FILTER-DATA-${actionTypeIdentifier}`;
export const setPageIndex = `SET-PAGE-INDEX-${actionTypeIdentifier}`;
export const setSortedColumnName = `SET-SORTED-COLUMN-NAME-${actionTypeIdentifier}`;
export const setOrderRequestFilter = `SET-ORDER-REQUEST-FILTER-${actionTypeIdentifier}`;
export const applyOrderRequestFilter = `APPLY-ORDER-REQUEST-FILTER-${actionTypeIdentifier}`;
export const resetRequestLogData = `RESET-REQUEST-LOG-DATA-${actionTypeIdentifier}`;